// Takes the entire viewport height minus the header height

import styled from "styled-components";

const FullHeight = styled.section`
    min-height: calc(100vh - var(--total-height-occupied-by-header));
    margin-top: calc(-1 * var(--total-height-occupied-by-header));
    padding-top: var(--total-height-occupied-by-header);

    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export default FullHeight;